import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';

const browserHistory = createBrowserHistory({ basename: '' });
const reactPlugin = new ReactPlugin();

const key = process.env.REACT_APP_APPINSIGHTS_INSTRUMENTATION_KEY;

let appInsights = null;

if (key) {
  appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: key,
      extensions: [reactPlugin],
      extensionConfig: {
        [reactPlugin.identifier]: { history: browserHistory },
      },
      // Performance optimizations
      disableFetchTracking: true, // Reduce network telemetry overhead
      disableAjaxTracking: false, // Keep AJAX tracking for errors
      maxBatchSizeInBytes: 10000, // Reduce payload size
      maxBatchInterval: 15000, // Send batches less frequently (15s instead of default)
      disableTelemetry: false, // Keep telemetry enabled
      enableAutoRouteTracking: true, // Track route changes
      enableCorsCorrelation: false, // Disable CORS correlation to reduce overhead
      disableExceptionTracking: false, // Keep exception tracking
      enableRequestHeaderTracking: false, // Reduce header tracking overhead
      enableResponseHeaderTracking: false, // Reduce header tracking overhead
    },
  });
  appInsights.loadAppInsights();
} else {
  console.warn('Application Insights instrumentation key not found. Analytics will be disabled.');
}

export { reactPlugin, appInsights };
